import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardEmpty, CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { formatDayMonth } from '../../../../Utils/dates/formatDate';
import styles from '../adminCards.module.css';

const TITLE = 'Recently joined';
const DAYS = 14;

const coachCell = row => {
    if (row.coach) return `${row.coach.firstName} ${row.coach.lastName}`;
    return row.role === 'Athlete' ? 'not linked' : '—';
};

const RecentlyJoinedCard = () => {
    const { status, data, error, reload } = useAsync(
        () => API.getAdminRecentUsers({ days: DAYS, limit: 10 }).then(res => res.data),
        []
    );

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (data && data.length === 0) body = <CardEmpty>No one has joined in the last {DAYS} days.</CardEmpty>;
    else if (data)
        body = (
            <ul className={styles.list}>
                {data.map(row => (
                    <li key={row.id}>
                        <div className={styles.jrow}>
                            <b style={{ fontWeight: 600 }}>{row.firstName} {row.lastName}</b>
                            <span>{row.role}</span>
                            <span>{coachCell(row)}</span>
                            <span>{formatDayMonth(row.createdAt)}</span>
                        </div>
                    </li>
                ))}
            </ul>
        );

    return (
        <Card id="nu" module="admin-joined" title={TITLE} sub={`last ${DAYS} days`} busy={status === 'loading'} flush>
            {body}
        </Card>
    );
};

export default RecentlyJoinedCard;
